document.addEventListener('DOMContentLoaded', () => {
  const faq_item = document.querySelectorAll(".faq_item");
  
  if (faq_item.length > 0){
    const first_item = faq_item[0];
    const first_faq_qus = first_item.querySelector(".faq_qus");
    const first_faq_ans = first_item.querySelector(".faq_ans");

    if (first_faq_qus && first_faq_ans){
        first_item.classList.add("open");
        first_faq_qus.classList.add("active");
        first_faq_ans.style.height = first_faq_ans.scrollHeight + "px";
    }
  }

  faq_item.forEach((item) => {
    const faq_qus = item.querySelector(".faq_qus");
    const faq_ans = item.querySelector(".faq_ans");

    if (faq_qus && faq_ans){
        faq_qus.addEventListener("click", function(){
            const isOpen = item.classList.contains("open");

            faq_item.forEach( i =>{
                const qus = i.querySelector(".faq_qus");
                const ans = i.querySelector(".faq_ans");

                if (qus && ans){
                    i.classList.remove("open");
                    qus.classList.remove("active");
                    ans.style.height = 0;
                }
            });

            if(!isOpen){
                item.classList.add("open");
                faq_qus.classList.add("active");
                faq_ans.style.height = faq_ans.scrollHeight + "px";
            }
        });
    }
  });
});